import { FC } from 'react'

import { useRegion } from '@/entities/regions'

import Flex from '@/shared/ui/Flex'
import { Col, Row } from '@/shared/ui/Grid'
import { Text } from '@/shared/ui/Typography'

import styles from './FooterShopInfo.module.scss'

export const FooterShopInfo: FC = () => {
	const { currentRegion } = useRegion()

	return (
		<div className={styles.footerShopInfo}>
			<Row gutter={[28, 28]}>
				{/* Title */}
				<Col span={24}>
					<Text weight="medium" color={`#fff`}>
						Связаться с нами
					</Text>
				</Col>

				{/* Info Item */}
				<Col xs={24} sm={8} xl={24}>
					{/* Phone number */}
					<a href={`tel:${currentRegion.REGION_PHONE}`} className={styles.phone}>
						{currentRegion.REGION_PHONE}
					</a>

					{/* Shop info */}
					<Flex column>
						<span className={styles.dop}>Горячая линия</span>
						<span className={styles.dop}>10:00 — 22:00, ежедневно</span>
					</Flex>
				</Col>
				<Col xs={24} sm={8} xl={24}>
					{/* Phone number */}
					<a href="tel:8(800)555-57-61" className={styles.phone}>
						8 (800) 555-57-61
					</a>

					{/* Shop info */}
					<Flex column>
						<span className={styles.dop}>Сервис центр</span>
						<span className={styles.dop}>10:00 — 22:00, ежедневно</span>
					</Flex>
				</Col>

				{/* Info Item */}
				<Col xs={24} sm={8} xl={24}>
					{/* Phone number */}
					<div className={styles.contacts}>
						<a href="tel:+78123183836" className={styles.phone}>
							+7 (812) 318-38-36
						</a>

						<a href="mailto:corp@iport.ru" className={styles.email} rel="noreferrer" target="_blank">
							corp@iport.ru
						</a>
					</div>

					{/* Shop info */}
					<Flex column>
						<span className={styles.dop}>Обслуживание юр.лиц</span>
						<span className={styles.dop}>10:00 — 18:00, Пн. - Пт.</span>
					</Flex>
				</Col>
			</Row>
		</div>
	)
}
